import { create } from 'zustand';

// the challenge dialog is open while space is set
export const useCloudflareChallengeStore = create(() => ({ space: null }));
